// Disable return types for import functions
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

// Directly import Home view for faster rendering of first page
import Home from '@/views/Home.vue';
import { isLogged, isAlreadyLogged } from '@/router/authentication';

/** @see https://router.vuejs.org/fr/essentials/navigation.html for help */
export const routes = [
	{
		path: '/',
		name: 'home',
		component: Home
	},
	{
		path: '/register',
		name: 'register',
		component: () => import('@/views/register/Register.vue'),
		redirect: '/register/information',
		children: [
			{
				path: 'information',
				name: 'registerInformation',
				components: {
					register: () => import('@/views/register/Information.vue')
				}
			},
			{
				path: 'document',
				name: 'registerDocument',
				components: {
					register: () => import('@/views/register/Document.vue')
				}
			},
			{
				path: 'identification',
				name: 'registerIdentification',
				components: {
					register: () => import('@/views/register/Identification.vue')
				}
			},
			{
				path: 'validation',
				name: 'registerValidation',
				components: {
					register: () => import('@/views/register/Validation.vue')
				}
			},
			{
				path: 'confirm',
				name: 'registerConfirm',
				components: {
					register: () => import('@/views/register/Confirm.vue')
				}
			}
		]
	},
	{
		path: '/dashboard',
		name: 'dashboard',
		component: () => import('@/views/dashboard/Dashboard.vue'),
		redirect: '/dashboard/status',
		beforeEnter: isLogged,
		children: [
			{
				path: 'status',
				name: 'dashboardStatus',
				components: {
					dashboard: () => import('@/views/dashboard/Status.vue')
				}
			},
			{
				path: 'information',
				name: 'dashboardInformation',
				components: {
					dashboard: () => import('@/views/dashboard/Information.vue')
				}
			},
			{
				path: 'documents',
				name: 'dashboardDocuments',
				components: {
					dashboard: () => import('@/views/dashboard/Documents.vue')
				}
			},
			{
				path: 'exchange',
				name: 'dashboardExchange',
				components: {
					dashboard: () => import('@/views/dashboard/Exchange.vue')
				}
			}
		]
	},
	{
		path: '/login',
		name: 'login',
		beforeEnter: isAlreadyLogged,
		component: () => import('@/views/Login.vue')
	},
	{
		path: '/faq',
		name: 'faq',
		component: () => import('@/views/Faq.vue')
	},
	{
		path: '/a-propos',
		name: 'about',
		// Route level code-splitting
		// This generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited
		component: () => import(
			/* webpackChunkName: "about" */
			'@/views/About.vue'
		)
	},
	{
		path: '/assistance',
		name: 'assistance',
		component: () => import(
			/* webpackChunkName: "maintenance" */
			'@/views/Assistance.vue'
		)
	},
	{
		path: '/maintenance',
		name: 'maintenance',
		component: () => import(
			/* webpackChunkName: "maintenance" */
			'@/views/Maintenance.vue'
		)
	},
	{
		path: '*', // Everything that doesn't match a route
		name: 'notFound',
		component: () => import(
			/* webpackChunkName: "not-found" */
			'@/views/NotFound.vue'
		)
	}
];
